import { root } from './sync';

export const sync = {
  ...root,
};
